module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    class: {
      '_bgcl-primary drop-shadow': _vm.isColor
    }
  }, [_c('div', {
    staticClass: "lo-container _h-100pct"
  }, [_c('div', {
    staticClass: "_dp-f _jtfct-spbtw _alit-ct"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("@/assets/logo-type.svg"),
      "height": "50",
      "alt": "logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_dp-n _dp-f-sm _alit-ct"
  }, [_c('router-link', {
    staticClass: "bio-link -white _pdh-16px _mgr-32px",
    attrs: {
      "to": {
        name: 'Introduction'
      }
    }
  }, [_c('strong', [_vm._v("Document")])]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    staticClass: "_dp-b _dp-n-sm _pst-rlt _w-64px _h-100pct _cs-pt",
    on: {
      "click": _vm.menuToggle
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade-spin",
      "mode": "out-in"
    }
  }, [(!_vm.isMenuOpen) ? _c('div', {
    staticClass: "_dp-f _alit-ct _jtfct-ct _pst-asl _r-0px _t-0px _w-64px _h-100pct"
  }, [_c('i', {
    staticClass: "fa fa-bars _cl-white _fs-4 _w-24px _h-24px _mg-auto _tal-ct"
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-spin",
      "mode": "out-in"
    }
  }, [(_vm.isMenuOpen) ? _c('div', {
    staticClass: "_dp-f _alit-ct _jtfct-ct _pst-asl _r-0px _t-0px _w-64px _h-100pct"
  }, [_c('i', {
    staticClass: "fa fa-close _cl-white _fs-4 _w-24px _h-24px _mg-auto _tal-ct"
  })]) : _vm._e()])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-in",
      "mode": "out-in"
    }
  }, [(_vm.isMenuOpen) ? _c('div', {
    staticClass: "_pst-asl _l-0px _w-100pct _pdh-4px",
    staticStyle: {
      "top": "56px"
    }
  }, [_c('div', {
    staticClass: "nav-mobile-menu-panel _bgcl-white _bdrd-2px _pd-16px u-rise-1 _ovf-at"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/BioMaRu/biomatic",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa _fs-3 fa-github bio-link -primary"
  }), _vm._v(" "), _c('span', {
    staticClass: "_cl-primary"
  }, [_c('strong', [_vm._v("Github")])])]), _vm._v(" "), _c('hr', {
    staticClass: "_opct-20 _mgbt-16px _mgt-16px"
  }), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion _mgbt-24px"
  }, [_c('input', {
    attrs: {
      "id": "accordion-getting-start",
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "_fs-5",
    attrs: {
      "for": "accordion-getting-start"
    }
  }, [_c('strong', [_vm._v("Getting Start")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion-content _pdv-8px"
  }, [_c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'Introduction'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  เกี่ยวกับ Biomatic\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'Installation'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  วิธีติดตั้ง\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'GettingStart'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  การใช้งาน ⭐️\n                ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion _mgbt-24px"
  }, [_c('input', {
    attrs: {
      "id": "accordion-atomic",
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "_fw-500 _fs-5",
    attrs: {
      "for": "accordion-atomic"
    }
  }, [_c('strong', [_vm._v("Atomic")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion-content _pdv-8px"
  }, [_c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicAlignment'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Alignment\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicBackground'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Background\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicBorder'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Border\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicBoxPosition'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Box Position\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicBoxSize'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Box Size\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicColor'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Color\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicCursor'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Cursor\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicDisplay'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Display\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicFloat'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Float\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicMargin'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Margin\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicObjectFit'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Object Fit\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicOpacity'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Opacity\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicOverflow'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Overflow\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicPadding'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Padding\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicTypography'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Typography\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'AtomicZIndex'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Z-Index\n                ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion _mgbt-24px"
  }, [_c('input', {
    attrs: {
      "id": "accordion-components",
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "_fw-500 _fs-5",
    attrs: {
      "for": "accordion-components"
    }
  }, [_c('strong', [_vm._v("Components")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion-content _pdv-8px"
  }, [_c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentAccordion'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Accordion\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentBreadcrumb'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Breadcrumb\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentButton'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Button\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentCard'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Card\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentForm'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Form\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentMessage'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Message\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentProgress'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Progress\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'ComponentTooltip'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Tooltip\n                ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion _mgbt-8px"
  }, [_c('input', {
    attrs: {
      "id": "accordion-layouts",
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "_fw-500 _fs-5",
    attrs: {
      "for": "accordion-layouts"
    }
  }, [_c('strong', [_vm._v("Layouts")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion-content _pdv-8px"
  }, [_c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'LayoutContainer'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Container\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'LayoutResponsiveGrid'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Responsive Grid\n                ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion _mgbt-8px"
  }, [_c('input', {
    attrs: {
      "id": "accordion-utilities",
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "_fw-500 _fs-5",
    attrs: {
      "for": "accordion-utilities"
    }
  }, [_c('strong', [_vm._v("Utilities")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion-content _pdv-8px"
  }, [_c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'UtilityAnimation'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Animation\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -item",
    attrs: {
      "to": {
        name: 'UtilityRise'
      },
      "active-class": '-active'
    }
  }, [_vm._v("\n                  Rise\n                ")])], 1)])])]) : _vm._e()])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://github.com/BioMaRu/biomatic",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa _fs-3 fa-github bio-link -white"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55d893bc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/TheNavbar.vue
// module id = 133
// module chunks = 0